import { ButtonDrawer, Modal } from '~/components'

export default function BasicModal({ title, message, buttons, isOpen, onClose, lightBackground, absolute }) {
  return (
    <>
      {isOpen && <Modal onClose={onClose} isOpen rounded absolute={absolute}>
        <div className="flex flex-col w-full p-4 gap-1.5">
          {title && <p className="text-[17px] font-semibold text-center text-[#17181a] mb-1">{title}</p>}
          {message && <div className="text-[15px] font-normal leading-[1.4] text-center text-[#5d5d5f]" dangerouslySetInnerHTML={{ __html: message }} />}
        </div>
        <ButtonDrawer buttons={buttons} modal />
      </Modal>}
    </>
  )
}
